// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__rCX5T"};